import { component } from 'picoapp';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default component((node) => {
  const sticky = node.classList.contains('is-sticky');

  if (sticky) {
    gsap.to(node, {
      opacity: 1,
      duration: 0.3,
      scrollTrigger: {
        trigger: 'body',
        start: 'top -40px',
        toggleActions: 'play pause reverse reset',
      }
    });
  }

  node.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  });
});